import { render } from "./UpsAndDowns.vue?vue&type=template&id=5a5deede&scoped=true"
import script from "./UpsAndDowns.vue?vue&type=script&lang=js"
export * from "./UpsAndDowns.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-5a5deede"

export default script